export default function How() {
  return (
    <>
      <section className="py-12 sm:py-16 bg-slate-50">
        <div className="main-content w-[90%] sm:w-[90%] md:w-[85%] m-auto">
          {/* Heading */}
          <div className="mb-8 sm:mb-10">
            <div className="flex justify-center">
              <span className="inline-flex justify-center items-center gap-2 text-center text-xs font-semibold text-white bg-gradient-to-r from-[#04003b] via-[#090979] to-[#00d4ff] px-3 py-1 rounded-full shadow-sm">
                <span className="w-1.5 h-1.5 rounded-full bg-white/90"></span>
                El Más Popular
              </span>
            </div>
            <h2 className="mt-3 sm:mt-4 text-xl sm:text-2xl md:text-3xl lg:text-4xl mx-auto font-black max-w-3xl leading-snug text-center">
              Suscripción Fácil y{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#04003b] via-[#090979] to-[#00d4ff]">
                Acceso Directo
              </span>
            </h2>
            <p className="mt-2 sm:mt-3 text-center text-slate-600 text-sm sm:text-base md:text-lg">
              El proceso es simple y rápido. Elige tu plan,
              completa el pago y recibe acceso inmediato a todo nuestro
              contenido premium.
            </p>
          </div>

          {/* Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 items-start">
            {/* Left: Gradient Steps Card */}
            <div className="relative rounded-xl sm:rounded-2xl p-4 sm:p-6 md:p-8 bg-gradient-to-br from-[#04003b] via-[#090979] to-[#00d4ff] text-white shadow-xl">
              <div className="absolute right-3 sm:right-5 top-3 sm:top-5 grid grid-cols-3 gap-1 opacity-40">
                {Array.from({ length: 9 }).map((_, i) => (
                  <span
                    key={i}
                    className="w-1 h-1 sm:w-1.5 sm:h-1.5 rounded-full bg-white/50"
                  ></span>
                ))}
              </div>
              <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
                <span className="text-lg sm:text-xl">✨</span>
                <h3 className="text-lg sm:text-xl md:text-2xl font-extrabold tracking-tight">
                  Cómo Funciona?
                </h3>
              </div>

              {/* Step items */}
              <div className="space-y-3 sm:space-y-5">
                <div className="rounded-lg sm:rounded-xl bg-white/10 backdrop-blur-sm p-3 sm:p-4 md:p-5 ring-1 ring-white/15">
                  <div className="flex items-start gap-3 sm:gap-4">
                    <span className="flex-shrink-0 w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-slate-900/90 flex items-center justify-center text-white font-extrabold text-sm sm:text-base">
                      01
                    </span>
                    <div>
                      <h4 className="font-bold text-white text-sm sm:text-base md:text-lg">
                        Elige Tu Plan
                      </h4>
                      <p className="text-white/90 text-xs sm:text-sm md:text-[15px]">
                        Selecciona el plan que mejor se adapte a tus
                        necesidades
                      </p>
                    </div>
                  </div>
                </div>
                <div className="rounded-lg sm:rounded-xl bg-white/10 backdrop-blur-sm p-3 sm:p-4 md:p-5 ring-1 ring-white/15">
                  <div className="flex items-start gap-3 sm:gap-4">
                    <span className="flex-shrink-0 w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-slate-900/90 flex items-center justify-center text-white font-extrabold text-sm sm:text-base">
                      02
                    </span>
                    <div>
                      <h4 className="font-bold text-white text-sm sm:text-base md:text-lg">
                        Completa el Pago
                      </h4>
                      <p className="text-white/90 text-xs sm:text-sm md:text-[15px]">
                        Proceso seguro y rápido para activar tu cuenta
                      </p>
                    </div>
                  </div>
                </div>
                <div className="rounded-lg sm:rounded-xl bg-white/10 backdrop-blur-sm p-3 sm:p-4 md:p-5 ring-1 ring-white/15">
                  <div className="flex items-start gap-3 sm:gap-4">
                    <span className="flex-shrink-0 w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-slate-900/90 flex items-center justify-center text-white font-extrabold text-sm sm:text-base">
                      03
                    </span>
                    <div>
                      <h4 className="font-bold text-white text-sm sm:text-base md:text-lg">
                        Disfruta Instantáneamente
                      </h4>
                      <p className="text-white/90 text-xs sm:text-sm md:text-[15px]">
                        Accede inmediatamente a todo el contenido premium
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Dots */}
              <div className="flex items-center gap-2 mt-6 justify-center">
                <span
                  className="w-2 h-2 rounded-full bg-white/70 animate-pulse"
                  style={{ animationDelay: "0ms", animationDuration: "1000ms" }}
                ></span>
                <span
                  className="w-2 h-2 rounded-full bg-white/90 animate-pulse"
                  style={{
                    animationDelay: "200ms",
                    animationDuration: "1000ms",
                  }}
                ></span>
                <span
                  className="w-2 h-2 rounded-full bg-white/70 animate-pulse"
                  style={{
                    animationDelay: "400ms",
                    animationDuration: "1000ms",
                  }}
                ></span>
              </div>
            </div>

            {/* Right: Detailed steps */}
            <div className="space-y-4 sm:space-y-5">
              <div className="rounded-xl sm:rounded-2xl bg-white p-4 sm:p-5 md:p-6 shadow-xl hover:shadow-2xl transition-all duration-500">
                <div className="flex items-start gap-3 sm:gap-4">
                  <span className="flex-shrink-0 w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-blue-100 text-blue-900 font-bold flex items-center justify-center text-sm sm:text-base">
                    1
                  </span>
                  <div>
                    <h4 className="font-semibold text-slate-900 flex items-center gap-2 text-sm sm:text-base">
                      <span className="text-blue-600">⚡</span>
                      Selecciona Tu Plan
                    </h4>
                    <p className="text-slate-600 text-xs sm:text-sm md:text-[15px]">
                      Elige entre nuestros planes premium diseñados para todas tus
                      necesidades.
                    </p>
                  </div>
                </div>
              </div>

              <div className="rounded-xl sm:rounded-2xl bg-white p-4 sm:p-5 md:p-6 shadow-xl hover:shadow-2xl transition-all duration-500">
                <div className="flex items-start gap-3 sm:gap-4">
                  <span className="flex-shrink-0 w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-blue-100 text-blue-900 font-bold flex items-center justify-center text-sm sm:text-base">
                    2
                  </span>
                  <div>
                    <h4 className="font-semibold text-slate-900 flex items-center gap-2 text-sm sm:text-base">
                      <span className="text-blue-600">✔</span>
                      Proceso de Pago Seguro
                    </h4>
                    <p className="text-slate-600 text-xs sm:text-sm md:text-[15px]">
                      Completa tu suscripción con nuestro sistema protegido y
                      confirmación instantánea.
                    </p>
                  </div>
                </div>
              </div>

              <div className="rounded-xl sm:rounded-2xl bg-white p-4 sm:p-5 md:p-6 shadow-xl hover:shadow-2xl transition-all duration-500">
                <div className="flex items-start gap-3 sm:gap-4">
                  <span className="flex-shrink-0 w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-blue-100 text-blue-900 font-bold flex items-center justify-center text-sm sm:text-base">
                    3
                  </span>
                  <div>
                    <h4 className="font-semibold text-slate-900 flex items-center gap-2 text-sm sm:text-base">
                      <span className="text-blue-600">▶</span>
                      Empieza a Disfrutar
                    </h4>
                    <p className="text-slate-600 text-xs sm:text-sm md:text-[15px]">
                      Accede inmediatamente a miles de canales, películas y
                      series en alta calidad.
                    </p>
                  </div>
                </div>
              </div>

              {/* CTA */}
              <div className="pt-1">
                <a
                  href="#pricing"
                  className="w-full md:w-auto inline-flex items-center justify-center gap-2 px-4 sm:px-6 py-2.5 sm:py-3 rounded-lg sm:rounded-xl text-white font-semibold shadow-md bg-gradient-to-r from-[#04003b] via-[#090979] to-[#00d4ff] hover:brightness-110 hover:scale-105 transition-all duration-500 text-sm sm:text-base min-h-[44px]"
                >
                  Empezar Ahora
                  <span className="text-white/90">→</span>
                </a>
                <p className="mt-2 sm:mt-3 text-center md:text-left text-xs text-slate-500">
                  Sin compromiso · Cancela cuando quieras · Soporte 24/7
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
